"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sheetTimeParamsMap = exports.sheetMusicSongProps = exports.recorderTimeParamsMap = exports.PreviewParamsEvent = exports.ABErrorMessage = void 0;
var sheetMusicSongProps = {
  song: Object,
  songConfig: Object,
  sheetOption: Object,
  playMode: {
    // 播放模式
    type: String,
    default: 'ori'
  },
  renderSheetOnly: {
    type: Boolean,
    default: false
  },
  action: {
    type: Object
  },
  platform: {
    type: String,
    default: 'pc'
  },
  loadSheetMode: {
    type: String,
    default: 'svgStr'
  },
  svgApi: {
    type: String,
    default: 'https://devpcloud-pre-render-service.ecoach.evideo.tech/sheet-svg/render-data'
  },
  onUploadRecordScore: {
    type: Function,
    default: function _default() {}
  },
  workerPublicPath: {
    type: String,
    default: ''
  },
  enableGesture: {
    type: Boolean,
    default: true
  },
  preSetMode: {
    type: Boolean,
    default: false
  },
  isPreset: {
    type: Boolean,
    default: false
  },
  preSetParams: {
    type: Object
  },
  showGoCreation: {
    type: Boolean,
    default: false
  }
};
exports.sheetMusicSongProps = sheetMusicSongProps;
var ABErrorMessage;
exports.ABErrorMessage = ABErrorMessage;

(function (ABErrorMessage) {
  ABErrorMessage[ABErrorMessage["\u64AD\u653E\u5931\u8D25"] = 0] = "\u64AD\u653E\u5931\u8D25";
  ABErrorMessage[ABErrorMessage["B\u70B9\u8BF7\u9009\u62E9\u97F3\u7B26"] = 1] = "B\u70B9\u8BF7\u9009\u62E9\u97F3\u7B26";
  ABErrorMessage[ABErrorMessage["B\u70B9\u8BF7\u9009\u62E9\u6B4C\u8BCD"] = 2] = "B\u70B9\u8BF7\u9009\u62E9\u6B4C\u8BCD";
  ABErrorMessage[ABErrorMessage["AB\u9009\u62E9\u4E0D\u7B26\u5408\u89C4\u5219"] = 3] = "AB\u9009\u62E9\u4E0D\u7B26\u5408\u89C4\u5219";
})(ABErrorMessage || (exports.ABErrorMessage = ABErrorMessage = {}));

var defaultMP3RecorderTimeParams = {
  isNeedGap: true,
  isNeedSrcTime: true,
  isNeedLyrics: true,
  isNeedLude: true
};
var defaultMIDIRecorderTimeParams = {
  isNeedGap: false,
  isNeedSrcTime: false,
  isNeedLyrics: true,
  isNeedLude: false
};
var defaultMp3SheetTimeParams = {
  isNeedGap: true,
  isNeedSrcTime: true,
  isNeedLyrics: true,
  isNeedLude: true,
  playBackSpeed: -1
};
var defaultMidiSheetTimeParams = {
  isNeedGap: false,
  isNeedSrcTime: false,
  isNeedLyrics: true,
  isNeedLude: true,
  playBackSpeed: -1
};
var recorderTimeParamsMap = {
  ori: defaultMP3RecorderTimeParams,
  acc: defaultMP3RecorderTimeParams,
  midiNoVolume: defaultMIDIRecorderTimeParams,
  midi: defaultMIDIRecorderTimeParams,
  rollCall: defaultMIDIRecorderTimeParams
};
exports.recorderTimeParamsMap = recorderTimeParamsMap;
var sheetTimeParamsMap = {
  ori: defaultMp3SheetTimeParams,
  acc: defaultMP3RecorderTimeParams,
  midiNoVolume: defaultMidiSheetTimeParams,
  midi: defaultMidiSheetTimeParams,
  rollCall: defaultMidiSheetTimeParams
}; // 预设参数事件

exports.sheetTimeParamsMap = sheetTimeParamsMap;
var PreviewParamsEvent = {
  CHANGE_PREVIEW_PARAMS: 'change-preview-params',
  SING_PLAY_PARAMS_CHANGE: 'sing-play-params-change'
};
exports.PreviewParamsEvent = PreviewParamsEvent;